import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PolizaSalud } from '../../../comun/model/salud.model';
import { CaButtonComponent } from '@global-front-components/ui/button';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RecomendadorColectiva } from '../../../comun/model/recomendador.model';
import { CaModalOverlayService, ModalConfig } from '@global-front-components/ui/modal-overlay';
import { ModalInformacionImagenComponent } from '../../../comun/components/modal-informacion-imagen/modal-informacion-imagen.component';
import { CaIcon } from '@global-front-components/ui/form-field';
import { ModalInformacionTarificacionComponent } from '../../../comun/components/modal-informacion-tarificacion/modal-informacion-tarificacion.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CaCheckboxComponent } from '@global-front-components/ui/checkbox';
import { ModalIframeCoberturasComponent } from '../modal-iframe-coberturas/modal-iframe-coberturas.component';

@Component({
	selector: 'app-tarificacion-salud',
	standalone: true,
	imports: [
		CommonModule,
		CaButtonComponent,
		TranslateModule,
		CaButtonComponent,
		CaIcon,
		CaCheckboxComponent
	],
	templateUrl: './tarificacion-salud.component.html',
	styleUrls: ['./tarificacion-salud.component.scss']
})
export class TarificacionSaludComponent implements OnInit {
	@Input() propuesta: PolizaSalud;
	@Input() colectiva: RecomendadorColectiva;
	@Input() propuestaDescuento?: PolizaSalud;
	@Input() colectivaDescuento?: RecomendadorColectiva;
	@Input() mostrarComparativoCoberturas: boolean = false;
	modalConfig: ModalConfig;
	esDescuento = false;

	constructor(
		private translateService: TranslateService,
		private _modalService: CaModalOverlayService,
		private sanitizer: DomSanitizer
	) {
	}

	ngOnInit(): void {
		this.modalConfig = {
			windowDrag: true,
			backdropClick: true,
			isBodyScrollable: true,
			closable: true,
			minimizable: false
		}
	}

	contratarPoliza() {
		console.log('Contratar poliza');
		console.log(this.propuesta);
	}

	imprimirPoliza() {

	}

	abrirModalInformacion() {
		this.translateService.get('SALUD.RECOMENDADOR.LABEL_OPCION.CONSULTAR_INFORMACION')
			.subscribe(title => {
				const modalConfig = this.modalConfig;
				modalConfig.data = { urlImagen: this.colectivaActiva.urlImagen };
				modalConfig.title = title;
				this._modalService.open(ModalInformacionImagenComponent, modalConfig);
			});
	}

	abrirModalTarificacion() {
		this.translateService.get('COMUN.DATOS_ECONOMICOS.DESGLOSE')
			.subscribe(title => {
				const modalConfig = this.modalConfig;
				modalConfig.data = { recibo: this.propuestaActiva?.recibo };
				modalConfig.title = title;
				this._modalService.open(ModalInformacionTarificacionComponent, modalConfig);
			});

	}

	getDescripcionModalidad(): SafeHtml {
		const raw = this.propuesta?.descripcionModalidadColectiva || '';
		const html = raw.replace(/\/n/g, '<br/>');
		return this.sanitizer.bypassSecurityTrustHtml(html);
	}

	changeDescuento(event: { source: any; checked: boolean }) {
		this.esDescuento = event.checked;
	}

	get propuestaActiva(): PolizaSalud {
		return this.esDescuento && this.propuestaDescuento ? this.propuestaDescuento : this.propuesta;
	}

	get colectivaActiva(): RecomendadorColectiva {
		return this.esDescuento && this.colectivaDescuento ? this.colectivaDescuento : this.colectiva;
	}

	getImporteMostrar(): number | null {
		const recibo = this.propuestaActiva?.recibo;
		const importePagos = recibo?.reciboPagosSucesivos?.importeTotal;
		const importeAnualidad = recibo?.reciboAnualidad?.importeTotal;

		if (importePagos && importePagos > 0) {
			return importePagos;
		} else if (importeAnualidad && importeAnualidad > 0) {
			return importeAnualidad;
		}
		return null;
	}

	abrirModalIntelij() {
		this.translateService.get('SALUD.RECOMENDADOR.LABEL_OPCION.CONSULTAR_COBERTURAS')
		.subscribe(title => {
				const modalConfig = this.modalConfig;
				modalConfig.title = title;
				this._modalService.open(ModalIframeCoberturasComponent, modalConfig);
			});
	}

}
